import {
  getCurrentToken,
  getRegion,
  getEnv,
} from '@adsk/acs-sc-web-platform-api';
import {
  DocsClass,
  DOCS_PRODUCTS,
  cancelAll,
  cancelRequests,
} from '@adsk/docs-js-sdk';

const getSDK = () => {
  const instance = new DocsClass({
    region: getRegion(),
    env: getEnv(),
    getToken: getCurrentToken,
    buildId: 'sheets_picker',
    product: DOCS_PRODUCTS.ACC,
  });
  return instance;
};

const sdk = getSDK();
const services = {
  Sheets: sdk.Sheets,
  VersionSets: sdk.VersionSets,
  DerivativeService: sdk.DerivativeService,
};

export { services as default, cancelAll, cancelRequests };
